module.exports = __webpack_public_path__ + "Roboto-Black.ab04c7611d94b690aee3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Black.svg
// module id = 196
// module chunks = 2